/******************************************************************************
 * FILE:
 * src/modules/wms/services/wmsTemplateChecklistService.js
 *
 * MODULE:
 * Work Management System (WMS)
 *
 * FEATURE:
 * Template Checklist Mapping
 *
 * PURPOSE:
 * Frontend API Client for
 * Template Checklist Mapping
 * Template Item Checklist Mapping
 ******************************************************************************/

import axiosClient from "../../../api/axiosClient";

/**
 * ----------------------------------------------------------------------
 * TEMPLATE CHECKLISTS
 * ----------------------------------------------------------------------
 */

/**
 * GET TEMPLATE CHECKLISTS
 *
 * Backend:
 * GET /api/wms/templates/:id/checklists
 */
async function getTemplateChecklists(
  templateId
) {

  const res = await axiosClient.get(
    `/api/wms/templates/${templateId}/checklists`
  );

  return res.data.data || [];
}

/**
 * CREATE TEMPLATE CHECKLIST
 *
 * Backend:
 * POST /api/wms/templates/:id/checklists
 */
async function createTemplateChecklist(
  templateId,
  payload
) {

  const res = await axiosClient.post(
    `/api/wms/templates/${templateId}/checklists`,
    payload
  );

  return res.data.data;
}

/**
 * UPDATE TEMPLATE CHECKLIST
 *
 * Backend:
 * PUT /api/wms/templates/:id/checklists/:mappingId
 */
async function updateTemplateChecklist(
  templateId,
  mappingId,
  payload
) {

  const res = await axiosClient.put(
    `/api/wms/templates/${templateId}/checklists/${mappingId}`,
    payload
  );

  return res.data.data;
}

/**
 * DELETE TEMPLATE CHECKLIST
 *
 * Backend:
 * DELETE /api/wms/templates/:id/checklists/:mappingId
 */
async function deleteTemplateChecklist(
  templateId,
  mappingId
) {

  const res = await axiosClient.delete(
    `/api/wms/templates/${templateId}/checklists/${mappingId}`
  );

  return res.data;
}

/**
 * ----------------------------------------------------------------------
 * TEMPLATE ITEM CHECKLISTS
 * ----------------------------------------------------------------------
 */

/**
 * GET TEMPLATE ITEM CHECKLISTS
 *
 * Backend:
 * GET /api/wms/template-items/:id/checklists
 */
async function getTemplateItemChecklists(
  templateItemId
) {

  const res = await axiosClient.get(
    `/api/wms/template-items/${templateItemId}/checklists`
  );

  return res.data.data || [];
}

/**
 * CREATE TEMPLATE ITEM CHECKLIST
 *
 * Backend:
 * POST /api/wms/template-items/:id/checklists
 */
async function createTemplateItemChecklist(
  templateItemId,
  payload
) {

  const res = await axiosClient.post(
    `/api/wms/template-items/${templateItemId}/checklists`,
    payload
  );

  return res.data.data;
}

/**
 * UPDATE TEMPLATE ITEM CHECKLIST
 *
 * Backend:
 * PUT /api/wms/template-items/:id/checklists/:mappingId
 */
async function updateTemplateItemChecklist(
  templateItemId,
  mappingId,
  payload
) {

  const res = await axiosClient.put(
    `/api/wms/template-items/${templateItemId}/checklists/${mappingId}`,
    payload
  );

  return res.data.data;
}

/**
 * DELETE TEMPLATE ITEM CHECKLIST
 *
 * Backend:
 * DELETE /api/wms/template-items/:id/checklists/:mappingId
 */
async function deleteTemplateItemChecklist(
  templateItemId,
  mappingId
) {

  const res = await axiosClient.delete(
    `/api/wms/template-items/${templateItemId}/checklists/${mappingId}`
  );

  return res.data;
}

/**
 * ----------------------------------------------------------------------
 * EXPORT
 * ----------------------------------------------------------------------
 */

const wmsTemplateChecklistService = {

  getTemplateChecklists,
  createTemplateChecklist,
  updateTemplateChecklist,
  deleteTemplateChecklist,

  getTemplateItemChecklists,
  createTemplateItemChecklist,
  updateTemplateItemChecklist,
  deleteTemplateItemChecklist,
};

export default wmsTemplateChecklistService;